
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 4v1a2 2 0 01-4 0V4a1 1 0 00-1.11-1 1 1 0 100 2 3.07 3.07 0 006.14 0 1 1 0 10-1-1zM4.3 2h7.4a1.53 1.53 0 011.53 1.38l.76 9a1.49 1.49 0 01-1.4 1.62H3.53A1.52 1.52 0 012 12.5a.49.49 0 010-.12l.76-9A1.53 1.53 0 014.3 2z"}})])
          )
        }
      }
    